// extracted by mini-css-extract-plugin
export default {"board":"board_board__aEtUB","outline":"board_outline__uBXMo","status":"board_status__Xq57B","fadeIn":"board_fadeIn__QEZ98","turn":"board_turn__3ipvE","btn":"board_btn__Ar-15"};